import { render, staticRenderFns } from "./v-card7.vue?vue&type=template&id=ad0481c0&scoped=true"
import script from "./v-card7.vue?vue&type=script&lang=js"
export * from "./v-card7.vue?vue&type=script&lang=js"
import style0 from "./v-card7.vue?vue&type=style&index=0&id=ad0481c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0481c0",
  null
  
)

export default component.exports